import numeral from 'numeral';
import { DENOMINATION_UNITS, getIdealDenomination } from 'utils/number';

export const spendFormatter = (value, withZero) => {
	const currencySymbol = '$';
	return value || withZero
		? getFormattedSpendWithSymbol(value, currencySymbol, true).toUpperCase()
		: '-';
};
export const getFormattedSpendWithSymbol = (
	value,
	currencySymbol,
	isDecimalEnable
) => {
	const denomination = getIdealDenomination(value);
	let displayValue = Math.abs(value / denomination);
	if (isDecimalEnable) {
		displayValue = displayValue.toFixed(1);
	}
	const decimal = '0';
	const formattedStr = numeral(displayValue).format(`0,0.${decimal}`);
	const negativePrefix = value < 0 ? '-' : '';

	return `${negativePrefix}${currencySymbol}${formattedStr}${
		DENOMINATION_UNITS[denomination]
	}`;
};

export const percentFormatter = value => {
	return getFormattedPercentage(value).toUpperCase();
};

export const getFormattedPercentage = value =>
	value === null || value === undefined
		? '-'
		: numeral(Math.abs(value) / 100).format('0,0.0%');
